import { ref, watch, onMounted } from 'vue';
import { useUserStore } from '@/stores/UserStore';
import useSettingsGlobals from '@/composables/useSettingsGlobals'

const { $PLATFORM, $WEB_VIEW } = useSettingsGlobals()  

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export default (initialValue, key, system = 'localStorage') => {
  if (system === 'off') return;
  
  const storageSystem = ref(system);
  const userStore = useUserStore();

  const returnValue = ref(initialValue)
  const loaded = ref(false)
  let storedValue;
  let response;
  let unwatch;

  onMounted(async () => {
    
    if (storageSystem.value === 'localStorage') {
      // We use url params instead of localStorage for webviews
      // This does not apply to apiUserStorage
      if ($WEB_VIEW) {
        storedValue = JSON.stringify(initialValue)
      } else {
        try {
          response = window.localStorage.getItem(key)
        } catch (err) {
          // localStorage can be blocked (Safari private mode / cookies
          // disabled), throwing SecurityError. Fall back to the initial value.
          response = null
        }
      }
    }
    
    if (storageSystem.value === 'webViewMessenger') {
      response = urlParams.get(key);
    }
    
    if (storageSystem.value === 'apiUserStorage') {
      response = await userStore.getAPIStorageItem(key);
    }
    
    storedValue = response ? response : initialValue;
    
    if (storedValue !== null && storedValue !== 'undefined') {
      try {
        returnValue.value = JSON.parse(storedValue)
      } catch (err) {
        if (err instanceof SyntaxError) {
          returnValue.value = storedValue // treat as plain string
        } else {
          throw err
        }
      } finally {
        loaded.value = true
      }
    }
  
    unwatch = watch(
      returnValue,
      (val) => {
        if (storageSystem.value === 'localStorage' && !$WEB_VIEW) {
          try {
            window.localStorage.setItem(key, JSON.stringify(val))
          } catch (err) {
            // storage blocked (Safari private mode / cookies disabled) or quota
            // exceeded — nothing we can persist, so skip rather than throw.
          }
        }
  
        if (storageSystem.value === 'webViewMessenger') {
          if ($PLATFORM === 'android') {
            const params = [key, val.toString()]
  
            alert(params.join(','))
          } else {
            const info = {
              type: key,
              value: val
            }
  
            window.webkit.messageHandlers.observe.postMessage(info)
          }
        }
  
        if (storageSystem.value === 'apiUserStorage') {
          userStore.updateAPIStorageItem(key, JSON.stringify(val))
        }
        
      },
      {
        deep: true
      }
    )
  })

  function updateStorageSystem(newSystem) {
    storageSystem.value = newSystem;
  }

  return [returnValue, loaded, unwatch, updateStorageSystem];
}